import React from 'react';
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {NetherlandsResponsibleGamingButtonsBox} from "./boxes/netherlands.responsible-gaming-buttons.box";
import {NetherlandsSelfTestButtonComponent} from "./self-test-button/netherlands.self-test-button.component";

export const NetherlandsResponsibleGamingButtonsComponent = observer(
    class NetherlandsResponsibleGamingButtonsComponent extends OrbitComponent {
        render() {
            return (
                <NetherlandsResponsibleGamingButtonsBox>
                    <NetherlandsSelfTestButtonComponent/>
                </NetherlandsResponsibleGamingButtonsBox>
            );
        }
    }
);